import React from 'react';
import logoLoader from '../../../assets/images/logos/TPP/logo_loader.svg';
import './ListLoader.scss';

export default function ListLoader() {
  return (
    <div className="ListLoader">
      <img
        className="logo-loader"
        src={logoLoader}
        alt="logoLoader"
      />
    </div>
  );
}
